import { render, staticRenderFns } from "./BrandUnit.vue?vue&type=template&id=0d83de62&"
import script from "./BrandUnit.vue?vue&type=script&lang=js&"
export * from "./BrandUnit.vue?vue&type=script&lang=js&"
import style0 from "./BrandUnit.vue?vue&type=style&index=0&id=0d83de62&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports